// src/components/GameBoard.jsx
import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import "./GameBoard.css";

const actors = [
    { id: "a1", name: "Iseult Brasselle", image: "/images/Iseult.png" },
    { id: "a2", name: "Lucas Hote", image: "/images/Lucas.png" },
    { id: "a3", name: "Théo Brevart", image: "/images/Theo.jpg" },
    { id: "a4", name: "Florence Delorme", image: "/images/Florence.png" },
    { id: "a5", name: "Clarisse Poucet", image: "/images/Clarisse.png" },
    { id: "a6", name: "Camille Dejean", image: "/images/Camille.png" },
];

const characters = [
    { id: "c1", name: "La Comptesse de Wurtenberg", image: "/images/Comptesse.png" },
    { id: "c2", name: "Hystérix la Gauloise", image: "/images/Hystérix.png" },
    { id: "c3", name: "Angela Secret", image: "/images/Angela.png" },
    { id: "c4", name: "Emo King", image: "/images/Emo.png" },
    { id: "c5", name: "Hairspray Becca", image: "/images/Becca.png" },
    { id: "c6", name: "Jungle Beast", image: "/images/Jungle.png" },
];

const GameBoard = ({ isVotingOpen }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedActors, setSelectedActors] = useState({});
    const [submitted, setSubmitted] = useState(localStorage.getItem("submitted") === "true");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [firstName, setFirstName] = useState(localStorage.getItem("firstName") || "");
    const [lastName, setLastName] = useState(localStorage.getItem("lastName") || "");

    const currentChar = characters[currentIndex];

    // Date de fin du vote
    const endDate = new Date(2026, 1, 13, 19, 0, 0); // 13 février 2026 19h

    // Acteurs disponibles pour ce personnage
    const availableActors = actors.filter(actor =>
        !Object.entries(selectedActors).some(
            ([charId, actorId]) => charId !== currentChar.id && actorId === actor.id
        )
    );

    const handleActorSelect = (actorId) => {
        if (!isVotingOpen) return;

        setSelectedActors(prev => ({ ...prev, [currentChar.id]: actorId }));

        // Passe automatiquement au personnage suivant si ce n'est pas le dernier
        if (currentIndex < characters.length - 1) setCurrentIndex(currentIndex + 1);
    };

    const handlePrevCharacter = () => {
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };

    const handleNextCharacter = () => {
        if (currentIndex < characters.length - 1) setCurrentIndex(currentIndex + 1);
    };

    const handleInitialSubmit = () => {
        if (!isVotingOpen) return alert("Les votes sont clos !");
        if (submitted) return;
        setIsModalOpen(true);
    };

    const handleFinalSubmission = async () => {
        if (!firstName.trim() || !lastName.trim()) return alert("Entre ton prénom et ton nom.");

        try {
            const submission = characters.map(c => ({
                characterId: c.id,
                character: c.name,
                actorId: selectedActors[c.id],
                actor: actors.find(a => a.id === selectedActors[c.id])?.name || "",
            }));

            await addDoc(collection(db, "submissions"), {
                submission,
                first_name: firstName,
                last_name: lastName,
                date: new Date(),
            });

            localStorage.setItem("submitted", "true");
            localStorage.setItem("firstName", firstName);
            localStorage.setItem("lastName", lastName);

            setSubmitted(true);
            setIsModalOpen(false);
            alert(`Merci ${firstName} ${lastName}, ta prévision est enregistrée !`);
        } catch (e) {
            console.error("Erreur soumission:", e);
            alert("Erreur lors de l'enregistrement. Réessaie plus tard.");
        }
    };

    const allSelected = Object.keys(selectedActors).length === characters.length;

    return (
        <div className="gameboard-container">
            {submitted ? (
                <p>Merci {firstName} {lastName}, tu as déjà parié.</p>
            ) : (
                <>
                    {!isVotingOpen && <p className="votes-closed">Les paris sont clos !</p>}

                    <div className="gameboard-scroll">


                        {/* Barre de progression */}
                        <p className="progress">Personnage {currentIndex + 1} / {characters.length}</p>

                        {/* Personnage */}
                        <div className="character-container">
                            <div className="character-card">
                                <img src={currentChar.image} alt={currentChar.name} />
                            </div>
                        </div>

                        <p className="instruction">Sélectionne le ou la catchereuse correspondant·e :</p>

                        {/* Acteurs disponibles */}
                        <div className="actor-list">
                            {availableActors.map(actor => {
                                const isSelected = selectedActors[currentChar.id] === actor.id;
                                return (
                                    <div
                                        key={actor.id}
                                        className={`actor-card ${isSelected ? "selected" : ""}`}
                                        onClick={() => handleActorSelect(actor.id)}
                                    >
                                        <img src={actor.image} alt={actor.name} />
                                        <b>{actor.name}</b>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Boutons fixes */}
                    <div className="button-group-fixed">
                        {currentIndex > 0 && <button onClick={handlePrevCharacter}>Précédent</button>}
                        {currentIndex < characters.length - 1 && <button onClick={handleNextCharacter}>Suivant</button>}
                        {allSelected && <button onClick={handleInitialSubmit}>Je parie là-dessus!</button>}
                    </div>
                </>
            )}

            {/* Modale */}
            {isModalOpen && (
                <div className="modal-backdrop">
                    <div className="modal-content">
                        <h3>Confirme ton pari</h3>
                        <p className="alert-text">ATTENTION : tu ne pourras parier qu'une seule fois !</p>
                        <input
                            placeholder="Prénom"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                        <input
                            placeholder="Nom"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                        />
                        <div className="button-group">
                            <button onClick={() => setIsModalOpen(false)}>Retour</button>
                            <button onClick={handleFinalSubmission} disabled={!firstName || !lastName}>
                                Je persiste et signe
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GameBoard;